<h2 mat-dialog-title class="text-lg font-bold mb-1">Filtrar por</h2>
<mat-dialog-content [formGroup]="form" class="w-full">
  <app-configuration-filters [form]="form" [loadData]="data.loadData">
  </app-configuration-filters>

  <app-business-partners-filters [form]="form" [businessGroupList]="groupList" [loadData]="data.loadData">
  </app-business-partners-filters>

  <app-routes-filters [form]="form" [territory]="true" [route]="true" [areaRoute]="true" [loadData]="data.loadData">
  </app-routes-filters>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Departamento</mat-label>
    <mat-select formControlName="locationTwoIds" [multiple]="true" placeholder="Seleccione departamentos">
      <mat-select-trigger>
        {{ getDisplayValue(listlocationTwo, form.get('locationTwoIds')?.value, 'name') }}
      </mat-select-trigger>

      <mat-option *ngFor="let department of listlocationTwo" [value]="department.code">
        <div class="text-sm uppercase leading-tight">
          <div>
            <b class="f-9" *ngIf="getCode(department) as code">{{ code }}</b>
          </div>
          {{ department.name }}
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Ciudad</mat-label>
    <mat-select formControlName="locationThreeIds" [multiple]="true" placeholder="Seleccione ciudades">
      <mat-select-trigger>
        {{ getDisplayValue(listlocationThree, form.get('locationThreeIds')?.value, 'name') }}
      </mat-select-trigger>

      <mat-option *ngFor="let city of listlocationThree" [value]="city.code">
        <div class="text-sm uppercase leading-tight">
          <div>
            <b class="f-9" *ngIf="getCode(city) as code">{{ code }}</b>
          </div>
          {{ city.name }}
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="onExportConfirm()">
    Exportar
  </button>
</mat-dialog-actions>
`,